// lazy component loading
const GamifyHomepage = () => import(/* webpackChunkName: "gamify" */ './GamifyHomepage.vue');

// new gamify
const NewGamify = () => import(/* webpackChunkName: "gamify" */ './NewGamify.vue');

const Gamify = () => import(/* webpackChunkName: "gamify" */ './Gamify.vue');
const Overview = () => import(/* webpackChunkName: "gamify" */ './gamify/Overview.vue');
const Edit = () => import(/* webpackChunkName: "gamify" */ './gamify/Edit.vue');
const Prizes = () => import(/* webpackChunkName: "gamify" */ './gamify/Prizes.vue');
const Settings = () => import(/* webpackChunkName: "gamify" */ './gamify/Settings.vue');
const Contests = () => import(/* webpackChunkName: "gamify" */ './gamify/Contests.vue');
const Contest = () => import(/* webpackChunkName: "gamify" */ './gamify/Contest.vue');
const NewContest = () => import(/* webpackChunkName: "gamify" */ './gamify/NewContest.vue');
const User = () => import(/* webpackChunkName: "gamify" */ './gamify/User.vue');
const Reports = () => import(/* webpackChunkName: "gamify" */ './gamify/Reports.vue');

import tutorialsteps from './tutorial';
import {routerTutorialGuard} from '@/providers/tutorial'

//ROUTES

export const routes = [{
  path: 'gamify',
  redirect: {name: 'gamify.homepage'},
  name: 'gamify',
  //empty component just for base
  component: {template: '<router-view/>'},
  meta: {
    trans: 'gamify:title',
    root: true,
  },
  children: [
    //DASHBOARD
    {
      path: 'home',
      name: 'gamify.homepage',
      component: GamifyHomepage,
      meta: {
        trans: 'gamify:titles.homepage',
        icon: 'gamify.logo',
      },
    },
    {
      path: ' ',
      redirect: {
        name: 'gamify.homepage'
      },
      name: ' ',
      meta: {
        trans: ' ',
        icon: '',
      },
    },
    // new gamify
    {
      path: 'new',
      name: 'gamify.new',
      component: NewGamify
    },
    {
      name: 'gamify.gamify',
      path: ':id',
      component: Gamify,
      props: true,
      redirect: {name: 'gamify.gamify.dashboard'},
      meta: {
        trans: 'gamify:single_title',
        up: 'gamify.homepage',
        root: true,
      },
      children: [
        {
          path: 'dashboard',
          component: Overview,
          name: 'gamify.gamify.dashboard',
          meta: {
            icon: 'home',
            trans: 'gamify:titles.dashboard',
          },
        },
        {
          path: 'design',
          component: Edit,
          name: 'gamify.gamify.design',
          meta: {
            icon: 'pencil',
            trans: 'gamify:titles.design',
          },
        },
        {
          path: 'contests',
          component: Contests,
          name: 'gamify.gamify.contests',
          meta: {
            icon: 'medal',
            trans: 'gamify:titles.contests',
          },
        },
        {
          path: 'contest/:contestid',
          name: 'gamify.contest',
          component: Contest,
          props: true
        },
        // new contest
        {
          path: 'newcontest',
          name: 'gamify.contests.new',
          component: NewContest,
          props: true
        },
        {
          path: 'prizes',
          component: Prizes,
          name: 'gamify.gamify.prizes',
          props: true,
          meta: {
            icon: 'trophy',
            trans: 'gamify:titles.prizes',
          },
        },
        {
          path: 'user',
          name: 'gamify.user',
          component: User,
          props: true
        },
        {
          path: 'settings',
          component: Settings,
          name: 'gamify.gamify.settings',
          meta: {
            icon: 'cog',
            trans: 'gamify:titles.settings',
          },
        },
        {
          path: 'reports',
          component: Reports,
          name: 'gamify.gamify.reports',
          meta: {
            icon: 'bargraph',
            trans: 'gamify:titles.reports',
          },
        },
      ]
    }
  ]
}];

// TRANSLATIONS
import en from './i18n/en'
import it from './i18n/it'
import sl from './i18n/sl'
import de from './i18n/de'
import fr from './i18n/fr'
import i18n from '@/providers/i18n'

for (let [lang, bundle] of Object.entries({en, it, sl, de, fr})) {
  i18n.i18next.addResourceBundle(lang, 'gamify', bundle);
}

export function guard(router) {
  router.afterEach((to, from) => {
    if (to.name && to.name.split('.')[0] === 'gamify') {
      import(/* webpackChunkName: "gamify" */ './style.scss');
    }
  })
  routerTutorialGuard(router, 'gamify', 'admin-yourgamify-tutorial', tutorialsteps);
}



// WEBPACK FOOTER //
// ./src/apps/gamify/index.js